import React from 'react'

import { Avatar } from '@wartek-id/avatar'
import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { Anchor } from 'components/Anchor'
import { useFeatureFlagContext } from 'utils/hooks/context/useFeatureFlagContext'

type TAvatarProfile = {
  src?: string
  name?: string
  url?: string
  email: string
}
const AvatarProfile = ({ email, url, name, src }: TAvatarProfile) => {
  const { getFeatureByKey } = useFeatureFlagContext()
  const isProfileLinkActive = getFeatureByKey('profileLink')

  return (
    <div className="flex items-center mb-4 relative">
      <Avatar src={src} name={name} alt={name} size="lg" />
      <div className="ml-3 flex flex-col">
        <Text variant="body" className="break-all">
          {name || email}
        </Text>
        {isProfileLinkActive && url && (
          <Anchor href={url}>
            <Text
              variant="helper-bold"
              className="break-all hover:underline overlay-link flex items-center"
            >
              Lihat profil
              <Icon fontSize="small" as="i" className="font-bold">
                chevron_right
              </Icon>
            </Text>
          </Anchor>
        )}
      </div>
    </div>
  )
}

export default AvatarProfile
